// @ts-nocheck
import { actions as sonataComponentsActions } from 'sonata-react-components';

import * as userActions from '../actions/user.actions';

const initialStore = {
  currentUser: null,
  manageUsers: null,
  showMasqueradeModal: false,
  showMasqueradeModalView: false
};

const actionsMap = {
  [userActions.SET_MASQUERADE_MODAL_SHOW]: (store, action) => {
    const { show } = action.data;
    return {
      ...store,
      showMasqueradeModal: show
    };
  },
  [userActions.SET_MASQUERADE_MODAL_SHOW_VIEW]: (store, action) => {
    const { show } = action.data;
    return {
      ...store,
      showMasqueradeModalView: show
    };
  },
  [userActions.SET_CURRENT_USER]: (store, action) => {
    const { user } = action.data;
    return {
      ...store,
      currentUser: user
    };
  },
  [sonataComponentsActions.UPDATE_CURRENT_USER_GROUPS]: (store, action) => {
    const { user } = action.data;
    return {
      ...store,
      currentUser: user
    };
  },
  [userActions.SET_MANAGE_USER]: (store, action) => {
    const { user } = action.data;
    return {
      ...store,
      manageUsers: {
        ...store.manageUsers,
        [user._id]: user
      }
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
